import { headerFunc } from "./common/_header";
import { commonFunc } from "./common/_common";
import { swiperFunc } from "./common/_swiper";

window.addEventListener('load', () => {
    commonFunc();
    headerFunc();
    swiperFunc();
});